import { createTheme } from '@mui/material/styles';

// WCAG AA compliant color palette
const theme = createTheme({
  palette: {
    primary: {
      main: '#000000', // Sony Black
      light: '#424242',
      dark: '#000000',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#000000', // Changed to black
      light: '#424242',
      dark: '#000000',
      contrastText: '#ffffff',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121', // 4.5:1 contrast ratio
      secondary: '#616161', // 4.5:1 contrast ratio
    },
    error: {
      main: '#d32f2f',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ed6c02',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2e7d32',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 16, // Base font size for better readability
    h1: {
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
          minHeight: 44,
          minWidth: 44,
          padding: '8px 16px',
          '&:focus-visible': {
            outline: '3px solid #000000',
            outlineOffset: '2px',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#0d47a1',
          textDecorationColor: '#0d47a1',
          textDecorationThickness: '2px',
          textUnderlineOffset: '2px',
          '&:hover': {
            color: '#0a3d91',
            textDecorationColor: '#0a3d91',
          },
          '&:focus-visible': {
            outline: '3px solid #000000',
            outlineOffset: '2px',
            borderRadius: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
        },
      },
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            position: 'static',
            transform: 'none',
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#1a1a1a',
            marginBottom: '4px',
          },
          '& .MuiInputBase-root': {
            minHeight: 28,
            marginTop: 0,
          },
          '& .MuiInputBase-input': {
            padding: '6px 10px',
          },
          '& .MuiInputBase-input:focus': {
            outline: '3px solid #000000',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
          '&:focus-visible': {
            outline: '3px solid #000000',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '9px',
          '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
          },
          '&:focus-visible': {
            outline: '3px solid #000000',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: 28,
          padding: '6px 10px',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            position: 'static',
            transform: 'none',
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#1a1a1a',
            marginBottom: '4px',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#0d47a1 !important',
            color: '#ffffff !important',
            fontWeight: 600,
            borderBottom: '2px solid #0a3d91',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#0d47a1 !important',
          color: '#ffffff !important',
          fontWeight: 600,
          borderBottom: '2px solid #0a3d91',
        },
      },
    },
  },
});

export default theme;